'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const DeliveryHermesAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { x: 0.5, y: 0.5, width: 83, height: 57, rx: 3.5, fill: "white" }),
      /* @__PURE__ */ jsx("rect", { x: 0.5, y: 0.5, width: 83, height: 57, rx: 3.5, stroke: "#F1F1F1" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.251 27.0278L23.0156 24H21.3015L20.5247 27.0278",
          fill: "url(#paint0_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.8098 27.0278L20.5867 24H5L7.71288 27.0278",
          fill: "url(#paint1_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.71288 27.0278L5 24V24.9618L7.26895 27.0397",
          fill: "url(#paint2_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.1909 30.97L22.017 27.9421H20.303L19.4768 30.97",
          fill: "url(#paint3_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.7616 30.9106L19.5877 27.8828H9.20483L11.967 30.9106",
          fill: "url(#paint4_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.967 30.9106L9.20483 27.8828V28.7852L11.5848 30.97",
          fill: "url(#paint5_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.204 34.8528L21.0302 31.825H19.3162L18.49 34.8528",
          fill: "url(#paint6_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.7754 34.8528L18.5523 31.825H13.4102L16.1724 34.8528",
          fill: "url(#paint7_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.2212 34.8528L13.459 31.825V32.6799L15.8389 34.8647",
          fill: "url(#paint8_linear_5448_6762)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M79 26.1729L78.7287 27.1822C78.6177 27.6571 78.3464 27.8234 77.7915 27.8234H76.1391C75.4239 27.8234 75.1403 27.8709 74.98 28.0371C74.8197 28.1915 74.758 28.4052 74.758 28.6783C74.758 28.9514 74.869 29.0464 75.3129 29.1532L76.9653 29.6282C78.1245 29.9488 78.4574 30.2694 78.4574 31.1124C78.4574 31.9673 78.1245 33.2972 77.6312 33.9265C77.138 34.5083 76.5214 34.7814 75.5842 34.7814H71.4779C71.145 34.7814 71.034 34.5677 71.0956 34.3065L71.5889 32.3354H72.0821C72.1931 32.7629 72.5261 32.9173 73.192 32.9173H74.795C75.3993 32.9173 75.6829 32.8104 75.8432 32.656C76.0035 32.5017 76.1145 32.1811 76.1145 31.9673C76.1145 31.5993 76.0035 31.4924 75.1773 31.3262L73.5249 30.8987C72.637 30.685 72.2548 30.21 72.2548 29.5095C72.2548 28.8208 72.5877 27.859 72.97 27.2178C73.4139 26.4698 74.1291 26.1492 75.3499 26.1492H79V26.1729ZM42.1419 28.3102C42.1419 28.9514 41.8706 30.0675 41.6486 30.495C41.4883 30.8156 41.2663 30.9224 40.4278 30.9224H36.5558L36.3955 31.6111C36.3462 31.7655 36.3462 31.9792 36.3462 32.1455C36.3462 32.466 36.4571 32.7273 36.7284 32.8935C36.9504 33.0479 37.3943 33.1072 38.1095 33.1072C39.6509 33.1072 39.9839 32.8935 40.4895 32.2523H40.9827L40.6498 33.4278C40.4278 34.2827 40.3785 34.4371 40.0455 34.6033C39.6016 34.8171 38.7754 34.9239 37.4436 34.9239C36.2229 34.9239 35.4583 34.8171 35.0144 34.6033C34.3485 34.2827 33.9662 33.5347 33.9662 32.5848C33.9662 30.9937 34.7924 28.5358 35.6186 27.5265C36.4448 26.5173 37.493 26.1373 39.318 26.1373C41.3033 26.066 42.1912 26.7666 42.1419 28.3102ZM40.2058 28.5714C40.2058 27.9302 39.8236 27.669 38.9357 27.669C37.7766 27.669 37.3327 28.0965 36.9504 29.4738H40.0332C40.1442 29.0464 40.2058 28.8327 40.2058 28.5714ZM70.7627 28.3102C70.7627 28.9514 70.4914 30.0675 70.2694 30.495C70.1091 30.8156 69.8255 30.8631 68.9993 30.8631H65.1273L64.967 31.5518C64.9177 31.7061 64.9177 31.9198 64.9177 32.0861C64.9177 32.4067 65.0287 32.6679 65.3 32.8341C65.5219 32.9885 65.9658 33.0479 66.681 33.0479C68.2225 33.0479 68.5554 32.8341 69.061 32.1929H69.5542L69.2213 33.3685C68.9993 34.2234 68.95 34.3777 68.6171 34.544C68.1731 34.7577 67.3469 34.8646 66.0152 34.8646C64.7944 34.8646 64.0298 34.7577 63.5859 34.544C62.92 34.2234 62.5378 33.4753 62.5378 32.5254C62.5378 30.9343 63.3639 28.4764 64.1901 27.4672C65.0163 26.4579 66.0645 26.0779 67.8895 26.0779C69.9365 26.066 70.812 26.7666 70.7627 28.3102ZM68.8267 28.5714C68.8267 27.9302 68.4444 27.669 67.5566 27.669C66.3974 27.669 65.9535 28.0965 65.5712 29.4738H68.6664C68.7774 29.0464 68.8267 28.8327 68.8267 28.5714ZM34.2868 24.475C34.3362 24.2137 34.1759 24 33.9046 24H31.4137L31.3643 24.3206C31.8083 24.4275 31.6356 24.9024 31.5863 25.1161C31.4753 25.5911 30.8094 27.9896 30.8094 27.9896H27.443L28.3802 24.475C28.4295 24.2137 28.3308 24 27.9979 24H25.507L25.4577 24.3206C25.9016 24.4275 25.729 24.9024 25.6796 25.1161C25.3467 26.5529 23.1887 34.4252 23.1887 34.4252C23.1394 34.639 23.238 34.9002 23.571 34.9002H26.0619L26.1112 34.5796C25.6673 34.4727 25.8399 33.9978 25.8893 33.784C25.9386 33.5703 26.9374 29.7351 26.9374 29.7351H30.3039L29.0337 34.4134C28.9844 34.6271 29.0831 34.8883 29.416 34.8883H31.9069L31.9562 34.5677C31.5123 34.4608 31.685 33.9859 31.7343 33.7722C31.8576 33.5703 34.2868 24.475 34.2868 24.475ZM60.3674 26.1254H59.1467C58.5424 26.1254 58.2095 26.2323 57.8149 26.8141L57.371 27.5028C57.4203 26.8141 57.038 26.1135 55.8295 26.1135H54.7197C53.7826 26.1135 53.5606 26.4816 53.3386 26.7547L52.8454 27.3959L53.0673 26.6479C53.1167 26.4341 53.018 26.1729 52.6851 26.1729H50.4778L50.3668 26.4935C50.5888 26.541 50.6997 26.7072 50.6997 26.8616C50.6997 26.9685 50.6997 27.016 50.6504 27.1822L48.7144 34.4134C48.6651 34.6271 48.7637 34.8883 49.0967 34.8883H51.304L51.3533 34.5677C51.1313 34.5202 51.082 34.354 51.082 34.2471C51.082 34.1996 51.082 34.0928 51.1313 33.879C51.1313 33.879 52.4015 29.3551 52.4015 29.3076C52.6727 28.1321 53.0057 28.0252 53.6716 27.9184C53.7826 27.9184 53.8935 27.9184 54.1155 27.9184C54.7197 27.9184 54.9417 28.2865 54.8307 28.7139C54.8307 28.8208 53.3386 34.4609 53.3386 34.4609C53.2893 34.6746 53.388 34.9358 53.7209 34.9358H55.9282L55.9775 34.6152C55.7556 34.5677 55.7062 34.4015 55.7062 34.2946C55.7062 34.2471 55.7062 34.1403 55.7556 33.9265L57.0257 29.3551C57.3586 28.1796 57.6299 28.0727 58.2958 27.9659C58.4068 27.9659 58.5178 27.9659 58.7397 27.9659C59.4056 27.9659 59.5659 28.334 59.4549 28.7614C59.4549 28.8089 57.9629 34.5083 57.9629 34.5083C57.9135 34.7221 58.0122 34.9833 58.3451 34.9833H60.5524L60.6017 34.6627C60.3798 34.6152 60.3305 34.449 60.3305 34.3421C60.3305 34.2946 60.3305 34.1878 60.3798 33.974C60.3798 33.974 61.8719 28.2271 61.9212 27.9659C62.0815 27.3009 62.0815 26.1254 60.3674 26.1254ZM47.9992 26.1729C47.4443 26.1729 47.395 26.1729 47.1113 26.541L46.4455 27.3959L46.6674 26.6479C46.7167 26.4341 46.6181 26.1729 46.2852 26.1729H44.0779L44.0285 26.4935C44.2505 26.541 44.2998 26.7072 44.2998 26.8141C44.2998 26.8616 44.2998 26.9685 44.2505 27.1822L42.3145 34.4134C42.2652 34.6271 42.3638 34.8883 42.6968 34.8883H44.9041L44.9534 34.5677C44.7314 34.5202 44.6821 34.354 44.6821 34.2471C44.6821 34.1996 44.6821 34.0928 44.7314 33.879L46.0015 29.2482C46.2728 28.1796 46.5564 27.9659 47.5429 27.9659H48.4308C49.0967 27.9659 49.3186 27.8115 49.4296 27.3247L49.7626 26.2085L47.9992 26.1729Z",
          fill: "#3C3C41"
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint0_linear_5448_6762",
            x1: 22.0626,
            y1: 27.0794,
            x2: 21.5344,
            y2: 23.9669,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#646469" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.458, stopColor: "#A9A9AE" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.82, stopColor: "#D9D9DE" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#EBEBF0" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint1_linear_5448_6762",
            x1: 8.841,
            y1: 28.3972,
            x2: 17.7108,
            y2: 20.6675,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#E6F0F5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.062, stopColor: "#CBE4EF" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.198, stopColor: "#96CDE4" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.335, stopColor: "#68B9DA" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.472, stopColor: "#42A9D1" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.607, stopColor: "#259CCB" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.741, stopColor: "#1193C7" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.873, stopColor: "#048EC4" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#008CC3" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint2_linear_5448_6762",
            x1: 4.14897,
            y1: 23.6208,
            x2: 7.71695,
            y2: 27.4579,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#E6F0F5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.092, stopColor: "#DDECF3" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.241, stopColor: "#C5E1EE" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.43, stopColor: "#9DD0E5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.65, stopColor: "#66B8D9" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.895, stopColor: "#209ACA" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#008CC3" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint3_linear_5448_6762",
            x1: 21.0333,
            y1: 30.9753,
            x2: 20.5047,
            y2: 27.8629,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#646469" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.458, stopColor: "#A9A9AE" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.82, stopColor: "#D9D9DE" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#EBEBF0" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint4_linear_5448_6762",
            x1: 9.17984,
            y1: 29.3972,
            x2: 19.5962,
            y2: 29.3972,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#E6F0F5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.105, stopColor: "#C0DEEA" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.283, stopColor: "#86C2DA" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.454, stopColor: "#56ABCC" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.616, stopColor: "#3199C2" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.765, stopColor: "#168DBA" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.898, stopColor: "#0685B6" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#0082B4" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint5_linear_5448_6762",
            x1: 8.62931,
            y1: 27.8397,
            x2: 12.0027,
            y2: 31.1066,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#E6F0F5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.16, stopColor: "#C7E1EC" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.512, stopColor: "#77BBD6" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#0082B4" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint6_linear_5448_6762",
            x1: 20.0384,
            y1: 34.8598,
            x2: 19.5102,
            y2: 31.7487,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#646469" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.458, stopColor: "#A9A9AE" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.82, stopColor: "#D9D9DE" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#EBEBF0" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint7_linear_5448_6762",
            x1: 13.2938,
            y1: 32.4313,
            x2: 18.1313,
            y2: 33.5913,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#E6F0F5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.104, stopColor: "#C6E0EB" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.348, stopColor: "#80BDD6" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.567, stopColor: "#49A2C5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.755, stopColor: "#218EB9" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.903, stopColor: "#0981B2" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.994, stopColor: "#007DAF" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint8_linear_5448_6762",
            x1: 13.0273,
            y1: 31.8792,
            x2: 16.5027,
            y2: 35.2449,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#E6F0F5" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.332, stopColor: "#90C5DB" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.657, stopColor: "#439EC3" }),
              /* @__PURE__ */ jsx("stop", { offset: 0.886, stopColor: "#1386B5" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#007DAF" })
            ]
          }
        )
      ] })
    ]
  }
);
const VpDeliveryHermesAsset = forwardRef(DeliveryHermesAsset);

export { VpDeliveryHermesAsset as default };
